// extracted by mini-css-extract-plugin
export default {"discussionCommentContainer":"HorizontalLinearStepper_discussionCommentContainer__CeOS8"};